export const INIT_BOX = "INIT_BOX";
export const BOX_FOUND = "BOX_FOUND";
export const INSERT_SERIAL_NUM = "INSERT_SERIAL_NUM";
export const INSERT_RP115s_PERMITTED = "INSERT_RP115S_PERMITTED";
export const BOX_NOT_FOUND = "BOX_NOT_FOUND";
export const INIT_BOX_CONNECTION = "INIT_BOX_CONNECTION";
export const INIT_BOX_CONNECTION_FOUND = "INIT_BOX_CONNECTION_FOUND";
export const INIT_BOX_CONNECTION_NOT_FOUND = "INIT_BOX_CONNECTION_NOT_FOUND";
export const WIFI_SCAN = "WIFI_SCAN";
export const WIFI_SCAN_SUCCESS = "WIFI_SCAN_SUCCESS";
export const WIFI_SCAN_FAILURE = "WIFI_SCAN_FAILURE";
export const SELECT_WIFI = "SELECT_WIFI";
import storage from "../../utils/storage";

export function initBox(serialNumber) {
  return {
    type: INIT_BOX,
    meta: {
      endpoint: "/installer/box?serial_number=" + serialNumber,
      success: initBoxSuccess,
      error: initBoxError,
    },
  };
}

function initBoxSuccess(response) {
  if (response.status === "NOT FOUND") {
    return {
      type: BOX_NOT_FOUND,
    };
  }
  storage.save({ key: "serialNum", data: response.data.serial_number });
  storage.save({
    key: "rp115sPermitted",
    data: response.data.rp115s_permitted,
  });
  return {
    type: BOX_FOUND,
    payload: {
      serialNumber: response.data.serial_number,
      rp115sPermitted: response.data.rp115s_permitted,
    },
  };
}

function initBoxError() {
  storage.save({ key: "serialNum", data: null });
  storage.save({ key: "rp115sPermitted", data: null });
  return {
    type: BOX_NOT_FOUND,
  };
}

export function initBoxConnection(serialNumber) {
  return {
    type: INIT_BOX_CONNECTION,
    meta: {
      endpoint: "/installer/box/status?serial_number=" + serialNumber,
      success: initBoxConnectionSuccess,
      error: initBoxConnectionError,
    },
  };
}

export function insertSerialNum(serialNumber) {
  return {
    type: INSERT_SERIAL_NUM,
    payload: { serialNumber },
  };
}

export function insertRp115sPermitted(rp115sPermitted) {
  return {
    type: INSERT_RP115s_PERMITTED,
    payload: { rp115sPermitted },
  };
}

function initBoxConnectionSuccess(response) {
  console.log(response);
  if (response.status === "OK") {
    if (response.data.connected === true) {
      return {
        type: INIT_BOX_CONNECTION_FOUND,
      };
    } else {
      return {
        type: INIT_BOX_CONNECTION_NOT_FOUND,
      };
    }
  }
}

function initBoxConnectionError() {
  console.log("ERROR");
  return {
    type: INIT_BOX_CONNECTION_NOT_FOUND,
  };
}

export function wifiScan(serialNumber) {
  return {
    type: WIFI_SCAN,
    meta: {
      endpoint: "/installer/box/wifi?serial_number=" + serialNumber,
      success: wifiScanSuccess,
      error: wifiScanFailure,
    },
  };
}

function wifiScanSuccess(response) {
  if (response.status === "OK") {
    return {
      type: WIFI_SCAN_SUCCESS,
      payload: response.data,
    };
  } else {
    return {
      type: WIFI_SCAN_FAILURE,
    };
  }
}

function wifiScanFailure() {
  return {
    type: WIFI_SCAN_FAILURE,
  };
}

export function selectNetwork(essid, strength, quality, channel) {
  return {
    type: SELECT_WIFI,
    payload: { essid, strength, quality, channel },
  };
}

// export function wifiConnectInit()



// WEBPACK FOOTER //
// ./src/redux/actions/box.js